import { AdminRequestFactory } from "./AdminRequestFactory";
import { AdminRequestInterface } from "../client/AdminRequest";
import { GeneralSettings, Logger, LogManager } from "..";
import { MessageSubscriber } from "./MessageSubscriber";

export class BroadcastMessageHandler {
    private static broadcastSubscriber: MessageSubscriber;
    private static log: Logger;

    public static async init() {
        if (this.broadcastSubscriber == null && GeneralSettings.getSingleton().isMessagingEnabled()) {
            this.broadcastSubscriber = new MessageSubscriber("broadcastMessage", false, message => {
                BroadcastMessageHandler.handleBroadcastMessage(message as AdminRequestInterface);
            });
            this.getLog().debug("BroadcastMessageHandler initialized");
        }
    }

    private static handleBroadcastMessage(message: AdminRequestInterface) {
        this.getLog().debug(() => ["Received broadcast message", message, "from", message?.originator]);
        const typedMessage = new AdminRequestFactory().create(message);
        if (typedMessage == null) {
            this.getLog().debug("Message could not be handled, likely is of an unknown type.");
            return;
        }
        if (typedMessage.isForMe() === true)
            typedMessage.handle();
        else
            this.getLog().debug("Message was not intended for this instance.");
    }

    private static getLog(): Logger {
        if (this.log == null)
            this.log = LogManager.getLogger("core.messaging.BroadcastMessageHandler");
        return this.log;
    }
}
